<template>
  <div :class="userAgent.device.type === 'desktop' ? '' : 'pb-24'">
    <modal
      name="contact-details"
      width="90%"
      :maxWidth="480"
      height="auto"
      :adaptive="true"
      scrollable
    >
      <div class="w-full">
        <form id="contact-details">
          <div class="px-1 py-2 flex border-b mb-4">
            <div :class="['text-md font-bold flex-grow ml-4 flex self-center']">
              {{ menu.restaurant_name }}
            </div>

            <div
              class="h-10 w-10 rounded-full flex justify-center items-center"
            >
              <a
                @click="$modal.hide('contact-details')"
                class="rounded-full cursor-pointer bg-background-red h-8 w-8 flex justify-center items-center"
                :style="btnDestructiveBackground"
              >
                <svg
                  :class="[
                    'fill-current inline-block h-6 w-6 rounded-full cursor-pointer',
                  ]"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  :style="btnDestructiveText"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div class="px-4">
            <div class="mb-4">
              <label
                class="block uppercase tracking-wide text-xs font-bold mb-2 text-product-gray"
                for="name"
                >{{ lang["full_name"][language] }}</label
              >

              <input
                v-model="visitorName"
                name="name"
                class="appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 text-black bg-white focus:border-primary-300 border-1.5 border-product-gray"
                id="name"
                type="text"
                :placeholder="lang['full_name'][language]"
              />
            </div>
            <div class="mb-6">
              <label
                class="block uppercase tracking-wide text-xs font-bold mb-2 text-product-gray"
                for="email"
                >Email</label
              >
              <input
                v-model="visitorEmail"
                :class="[
                  { 'border-red-500': !validEmail },
                  'appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 focus:border-primary-300 border-1.5 border-product-gray text-black bg-white',
                ]"
                id="email"
                type="email"
                placeholder="john@example.com"
              />
              <p class="text-red-500 text-xs italic" v-if="!validEmail">
                {{ lang["please_enter_valid_email"][language] }}
              </p>
            </div>
            <div class="mb-4">
              <label
                class="block uppercase tracking-wide text-xs font-bold mb-2 text-product-gray"
                for="name"
                >{{ lang["phone"][language] }}</label
              >
              <input
                v-model="visitorPhone"
                name="phone"
                class="appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 focus:border-primary-300 border-1.5 border-product-gray text-black bg-white"
                id="phone"
                type="text"
                :placeholder="lang['phone'][language]"
              />
            </div>
            <div class="mb-4">
              <label
                class="block uppercase tracking-wide text-xs font-bold mb-2 text-product-gray"
                for="name"
                >{{ lang["table"][language] }}</label
              >
              <input
                v-model="stickerId"
                name="table"
                class="appearance-none block w-full rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 focus:border-primary-300 border-1.5 border-product-gray text-black bg-white"
                id="table"
                type="text"
                :placeholder="lang['table'][language]"
              />
            </div>
            <div class="mb-4">
              <label class="flex justify-start items-start mb-2">
                <div
                  class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500"
                >
                  <input
                    v-model="marketingConsent"
                    type="checkbox"
                    class="opacity-0 absolute"
                  />
                  <svg
                    class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <span class="select-none text-gray-700">{{
                  lang["marketing_consent_description"][language]
                }}</span>
              </label>
              <p class="text-gray-500" v-if="!marketingConsent">
                <small>{{ lang["data_deletion_message"][language] }}</small>
              </p>
            </div>
          </div>
          <div class="px-6 py-4 flex justify-end">
            <button
              @click="$modal.hide('contact-details')"
              class="text-sm rounded-large text-gray-500 px-2 py-1 mr-2 h-8 transition duration-500 border-1.5"
              type="button"
            >
              <span>{{ lang["cancel"][language] }}</span>
            </button>
            <button
              @click="allFieldsFilled ? submitContactDetails() : ''"
              :class="[
                'text-center p-2 rounded-full text-sm h-8 flex items-center justify-center transition duration-500',
                /* theme.addToCart.addToCartButtonBackgroundColor */ 'bg-new-primary',
              ]"
              type="button"
              :style="makeStyles(hasKiosk && mainButtonRadius, btnMainBackground, btnMainText)"
            >
              <svg
                v-if="isSubmitting"
                style="animation: spin-animation 0.5s infinite"
                class="fill-current inline-block h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  class="heroicon-ui"
                  d="M6 18.7V21a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7.1A7 7 0 0 0 19 12a1 1 0 1 1 2 0 9 9 0 0 1-15 6.7zM18 5.3V3a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.9A7 7 0 0 0 5 12a1 1 0 1 1-2 0 9 9 0 0 1 15-6.7z"
                />
              </svg>
              <span>{{ lang["submit"][language] }}</span>
            </button>
          </div>
        </form>
      </div>
    </modal>
    <!-- <p
      v-if="menu.restaurant_description"
      class="text-gray-500 font-light p-3 bg-red-600"
    >
      {{ menu.restaurant_description }}
    </p> -->
    <div class="mx-auto lg:pt-5 lg:pb-5" v-if="!hasKiosk">
      <div 
      class="flex flex-wrap text-center justify-center pb-56 md:pb-8 mt-8">
        <div class="w-full">
          <div class="lg:px-10">
            <h3
              v-if="menu.restaurant_name"
              class="text-md font-semibold text-gray-600"
            >
              {{ menu.restaurant_name }}
            </h3>
            <p
              v-if="menu.restaurant_description"
              class="text-gray-500 font-light text-xs"
            >
              {{ menu.restaurant_description }}
            </p>
            <p
              class="text-gray-500 font-light text-xs"
              v-if="menu.restaurant_email || menu.restaurant_phone"
            >
              <a
                v-if="menu.restaurant_email"
                :href="'mailto:' + menu.restaurant_email"
                >{{ menu.restaurant_email }}</a
              >
              <span
              v-if="menu.restaurant_phone"
              class="px-1">|</span>
              <a
                v-if="menu.restaurant_phone"
                :href="'tel:' + menu.restaurant_phone"
                >{{ menu.restaurant_phone }}</a
              >
            </p>
            <div class="flex justify-center" v-if="menu.restaurant_reservation">
              <a
                :href="menu.restaurant_reservation"
                title="Reservation"
                target="_blank"
                :style="makeStyles(hasKiosk && mainButtonRadius,btnMainBackground)"
                class="flex p-2 items-center  rounded-xl"
              >
                <svg
                  class="fill-current cursor-pointer w-4 h-4 mr-1"
                  xmlns="http://www.w3.org/2000/svg"
                  height="512"
                  viewBox="0 0 512 512"
                  width="512"
                >
                  <g>
                    <path
                      d="m496 432h-64v-16h48a8 8 0 0 0 8-8v-32a231.974 231.974 0 0 0 -224-231.85v-8.15h32a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8h-80a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32v8.15a231.974 231.974 0 0 0 -224 231.85v32a8 8 0 0 0 8 8h48v16h-64a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8zm-272-312v-16h64v16zm-184 280v-24a216.007 216.007 0 0 1 368.74-152.74 214.619 214.619 0 0 1 63.26 152.74v24zm376 16v16h-320v-16zm72 64h-464v-32h464z"
                    />
                    <path d="m96 456h-56a8 8 0 0 0 0 16h56a8 8 0 0 0 0-16z" />
                    <path d="m128 456h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z" />
                    <path
                      d="m256 72a8 8 0 0 0 8-8v-40a8 8 0 0 0 -16 0v40a8 8 0 0 0 8 8z"
                    />
                    <path d="m144 120h40a8 8 0 0 0 0-16h-40a8 8 0 0 0 0 16z" />
                    <path
                      d="m320 112a8 8 0 0 0 8 8h40a8 8 0 0 0 0-16h-40a8 8 0 0 0 -8 8z"
                    />
                    <path
                      d="m186.611 76.922a8 8 0 0 0 11.063-11.559l-23.285-22.285a8 8 0 0 0 -11.063 11.559z"
                    />
                    <path
                      d="m312.858 79.143a7.977 7.977 0 0 0 5.531-2.221l23.285-22.285a8 8 0 1 0 -11.063-11.559l-23.285 22.285a8 8 0 0 0 5.532 13.78z"
                    />
                  </g>
                </svg>
                <span :style="btnMainText">{{
                  lang.reservation[language]
                }}</span>
              </a>
            </div>
          </div>
          <div class="flex justify-start items-center flex-col">
            <div
              v-if="menu.Id && menu.is_contact_popup_enabled"
              :class="['flex-1 text-left mb-4']"
            >
              <span
                class="text-xs text-gray-400"
                v-if="visitorDetailsSubmitted"
              >
                <span class="font-hairline">{{
                  lang["submitted_as"][language]
                }}</span>
                {{ visitorName }}&nbsp;
              </span>
              <a
                @click.prevent="show()"
                class="text-xs font-medium"
                :style="text"
                v-if="menu.is_contact_popup_enabled"
              >
                <span v-if="visitorDetailsSubmitted">{{
                  lang["resubmit"][language]
                }}</span>
                <span v-else>{{
                  lang["leave_contact_details"][language]
                }}</span>
              </a>
            </div>
            <div class="flex-1 text-gray-700">
              <div class="flex justify-end">
                  <a
                  v-if="menu.restaurant_phone"
                
                  :href="'tel:'+menu.restaurant_phone"
                  class="w-6 mx-1"
                  title="Phone Number"
                  target="_blank"
                >
                  <svg
                    class="fill-current cursor-pointer text-gray-500 hover:text-gray-600 w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  ><path d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"></path>
                  </svg>
                </a>

                <a
                  v-if="menu.restaurant_website"
                  :href="menu.restaurant_website"
                  class="w-6 mx-1"
                  title="Website"
                  target="_blank"
                >
                  <svg
                    class="fill-current cursor-pointer text-gray-500 hover:text-gray-600 w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512.001 512.001"
                    style="enable-background: new 0 0 512.001 512.001"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M430.387,77.731c-3.407-3.407-6.904-6.692-10.468-9.878c-0.055-0.05-0.11-0.098-0.165-0.147    C373.535,26.454,314.563,3.889,252.114,3.888c-0.009,0-0.018,0-0.027,0c-0.003,0-0.007,0-0.01,0    c-40.357,0.006-80.49,9.779-116.062,28.265c-18.297,9.509-35.417,21.345-50.901,35.047c-0.457,0.324-0.888,0.698-1.28,1.132    C70.689,80.121,58.747,93.262,48.34,107.52c-2.51,3.439-1.758,8.261,1.681,10.77c3.438,2.509,8.261,1.756,10.77-1.681    c8.679-11.89,18.399-22.832,28.966-32.764c17.31,14.583,36.355,26.664,56.606,36.021c-12.027,38.078-18.772,82.196-19.448,128.424    H15.546c1.092-34.807,9.582-68.122,25.298-99.133c1.924-3.797,0.406-8.435-3.393-10.36c-3.792-1.924-8.435-0.406-10.36,3.393    C9.114,177.666,0,215.956,0,256c0,67.341,26.225,130.653,73.842,178.271c47.618,47.618,110.93,73.842,178.271,73.842    c53.975,0,105.447-16.81,148.854-48.615c3.435-2.516,4.178-7.34,1.662-10.773c-2.515-3.436-7.339-4.177-10.773-1.663    c-26.958,19.752-57.235,33.337-89.313,40.273c6.364-5.538,12.496-12.146,18.333-19.802c2.582-3.385,1.929-8.222-1.456-10.803    c-3.384-2.584-8.223-1.93-10.803,1.456c-14.955,19.614-31.666,31.189-48.745,33.89l0.686-65.404    c0.044-4.257-3.37-7.743-7.628-7.788c-0.027,0-0.055,0-0.082,0c-4.219,0-7.661,3.399-7.706,7.628l-0.688,65.592    c-25.47-3.906-49.557-27.212-68.513-66.624c-3.966-8.246-7.602-16.998-10.904-26.18c15.631-6.185,31.946-10.705,48.704-13.436    c4.203-0.684,7.053-4.647,6.368-8.847c-0.685-4.203-4.648-7.053-8.847-6.368c-17.571,2.864-34.684,7.572-51.095,13.999    c-11.002-35.914-17.176-77.401-17.83-120.938h81.905c4.258,0,7.708-3.45,7.708-7.708c0-4.258-3.45-7.708-7.708-7.708h-81.905    c0.662-44.122,6.998-86.133,18.28-122.377c26.687,10.391,55.143,16.222,84.227,17.057l0.298,89.57    c0.014,4.249,3.463,7.683,7.707,7.683c0.009,0,0.018,0,0.027,0c4.257-0.014,7.696-3.477,7.683-7.734l-0.298-89.548    c28.382-0.913,56.158-6.574,82.259-16.596c7.024,23.119,11.974,48.64,14.482,75.369c0.398,4.239,4.153,7.355,8.395,6.954    c4.239-0.398,7.352-4.156,6.954-8.395c-2.656-28.303-7.974-55.382-15.555-79.921c20.63-9.416,40.027-21.646,57.628-36.467    c44.028,41.542,72.17,99.737,74.25,164.408H444.53c-4.258,0-7.708,3.45-7.708,7.708c0,4.258,3.45,7.708,7.708,7.708h44.152    c-1.382,42.949-14.294,84.459-37.566,120.502c-2.309,3.577-1.282,8.348,2.294,10.657c1.293,0.836,2.742,1.233,4.175,1.233    c2.529,0,5.008-1.245,6.483-3.528c26.273-40.694,40.161-87.92,40.161-136.574C504.229,188.661,478.004,125.349,430.387,77.731z     M162.044,432.161c11.402,23.706,24.783,42.239,39.465,55.071c-37.804-8.265-72.256-25.585-100.96-49.575    c15.447-12.896,32.354-23.694,50.324-32.208C154.265,414.798,157.988,423.729,162.044,432.161z M145.927,390.745    c-20.439,9.502-39.611,21.767-57.002,36.552c-43.527-41.485-71.303-99.347-73.37-163.588h111.36    C127.583,309.376,134.174,352.984,145.927,390.745z M151.377,105.181C133.6,96.82,116.83,86.222,101.478,73.543    c28.958-23.834,63.261-40.568,99.909-48.668c-14.636,12.829-27.973,31.324-39.343,54.964    C158.188,87.858,154.633,96.331,151.377,105.181z M165.551,111.29c3.165-8.666,6.626-16.948,10.388-24.768    c18.951-39.403,43.031-62.708,68.494-66.622l0.358,107.647C217.416,126.703,190.644,121.146,165.551,111.29z M260.207,127.519    l-0.358-107.545c20.507,3.472,40.841,20.595,57.985,49.109c7.545,12.549,14.198,26.899,19.836,42.602    C313.104,121.206,286.946,126.609,260.207,127.519z M351.865,105.648c-5.922-16.353-12.903-31.343-20.819-44.508    c-9.069-15.085-19.113-27.396-29.779-36.688c37.958,8.049,72.588,25.211,101.47,49.098    C387.105,86.46,370.003,97.219,351.865,105.648z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M393.191,276.041h0.001c-30.209-30.208-79.364-30.208-109.573,0.001c-30.209,30.21-30.209,79.364,0,109.573    c15.106,15.105,34.943,22.658,54.787,22.656c19.838-0.002,39.682-7.554,54.785-22.656c14.635-14.633,22.694-34.091,22.694-54.788    C415.886,310.132,407.826,290.676,393.191,276.041z M382.289,374.714c-24.197,24.199-63.572,24.199-87.768,0    c-24.199-24.198-24.199-63.572,0-87.769c12.098-12.099,27.991-18.148,43.884-18.148c15.893,0,31.786,6.049,43.884,18.148    c0,0,0,0,0.001,0c11.723,11.722,18.178,27.307,18.178,43.884C400.468,347.407,394.013,362.992,382.289,374.714z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M509.743,468.888l-77.914-77.915c11.49-17.77,17.656-38.482,17.656-60.145c0-29.67-11.554-57.565-32.534-78.544    c-43.311-43.309-113.778-43.309-157.089,0c-13.666,13.667-23.563,30.693-28.617,49.241c-1.119,4.107,1.303,8.344,5.41,9.464    c4.111,1.12,8.344-1.302,9.465-5.411c4.35-15.96,12.872-30.619,24.645-42.392c37.297-37.299,97.988-37.299,135.285,0    c18.069,18.067,28.02,42.09,28.02,67.642c0,25.553-9.951,49.575-28.02,67.643c-37.297,37.299-97.988,37.299-135.285,0    c-16.06-16.06-25.902-37.353-27.713-59.957c-0.339-4.244-4.06-7.39-8.298-7.069c-4.244,0.34-7.408,4.056-7.069,8.299    c2.103,26.252,13.531,50.981,32.179,69.629c21.655,21.654,50.1,32.482,78.545,32.482c20.947,0,41.89-5.879,60.126-17.622    l77.933,77.933c1.506,1.505,3.478,2.257,5.451,2.257c1.972,0,3.946-0.752,5.45-2.257l22.376-22.376    c1.446-1.446,2.258-3.406,2.258-5.451C512.001,472.293,511.188,470.335,509.743,468.888z M481.916,485.814l-70.703-70.703    l5.718-5.717c0.006-0.006,0.013-0.012,0.02-0.02c0.007-0.007,0.013-0.014,0.021-0.021l5.716-5.718l70.704,70.704L481.916,485.814z    "
                        />
                      </g>
                    </g>
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                  </svg>
                </a>
                <a
                  v-if="menu.restaurant_email"
                
                  :href="'mailto:'+menu.restaurant_email"
                  class="w-6 mx-1"
                  title="Mail"
                  target="_blank"
                >
                  <svg
                    class="fill-current cursor-pointer text-gray-500 hover:text-gray-600 w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                  ><path d="M5.25 4H18.75C20.483 4 21.8992 5.35645 21.9949 7.06558L22 7.25V16.75C22 18.483 20.6435 19.8992 18.9344 19.9949L18.75 20H5.25C3.51697 20 2.10075 18.6435 2.00514 16.9344L2 16.75V7.25C2 5.51697 3.35645 4.10075 5.06558 4.00514L5.25 4H18.75H5.25ZM20.5 9.373L12.3493 13.6637C12.1619 13.7623 11.9431 13.7764 11.7468 13.706L11.6507 13.6637L3.5 9.374V16.75C3.5 17.6682 4.20711 18.4212 5.10647 18.4942L5.25 18.5H18.75C19.6682 18.5 20.4212 17.7929 20.4942 16.8935L20.5 16.75V9.373ZM18.75 5.5H5.25C4.33183 5.5 3.57881 6.20711 3.5058 7.10647L3.5 7.25V7.679L12 12.1525L20.5 7.678V7.25C20.5 6.33183 19.7929 5.57881 18.8935 5.5058L18.75 5.5Z" fill="currentColor"></path>
                </svg>

                </a>
                <a
                  v-if="menu.restaurant_facebook"
                  :href="menu.restaurant_facebook"
                  class="w-6 mx-1"
                  title="facebook"
                  target="_blank"
                >
                  <svg
                    class="fill-current cursor-pointer text-gray-500 hover:text-gray-600 w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    id="Bold"
                    enable-background="new 0 0 24 24"
                    height="512"
                    viewBox="0 0 24 24"
                    width="512"
                  >
                    <path
                      d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323 5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z"
                    />
                  </svg>
                </a>
                <a
                  v-if="menu.restaurant_instagram"
                  :href="menu.restaurant_instagram"
                  class="w-6 mx-1"
                  title="Instagram"
                  target="_blank"
                >
                  <svg
                    class="fill-current cursor-pointer text-gray-500 hover:text-gray-600 w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    height="511pt"
                    viewBox="0 0 511 511.9"
                    width="511pt"
                  >
                    <path
                      d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0"
                    />
                    <path
                      d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"
                    />
                    <path
                      d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center flex-col">
          <div class="text-gray-400 text-xs">
            © Copyright 2024
            <a href="https://qr-menu.app" target="_blank">QR Menu App</a>. All
            Rights Reserved.
          </div>
          <div class="text-gray-400 text-xs">
            <a
              href="https://qr-menu.app/terms-and-conditions"
              target="_blank"
              >{{ lang["terms"][language] }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
      isSubmitting: false,
      validEmail: true,
      visitorDetailsSubmitted: this.$cookies.isKey("vds"),
      // stickerId: localStorage.getItem("stickerId") || "",
      tableId: "",
      allFieldsFilled: false,
    };
  },
  watch: {
    /**
     * Watch the email address change so that if it is not valid
     * the error validation can be turned on.
     *
     * @param {String} email Email address.
     */
    visitorEmail(email) {
      let emailRegularExpression = /\S+@\S+\.\S+/;
      this.validEmail = emailRegularExpression.test(email);
    },
  },
  computed: {
    ...mapGetters([
      "userAgent",
      "menu",
      "language",
      "theme",
      "hasKiosk",
      "currentKioskMode",
      "visitorPhone",
      "visitorEmail",
      "visitorName",
    ]),
    ...mapGetters("Cart", ["tables","stickerId"]),
    ...mapGetters("Theme", [
      "mainButtonRadius",
      "btnMainBackground",
      "btnMainText",
      "btnDestructiveBackground",
      "btnDestructiveText",
      "btnThirdBackground",
      "btnThirdText",
      "text",
    ]),
    /** Visitor Name */
    visitorName: {
      get() {
        return this.$store.getters.visitorName;
      },
      set(value) {
        this.$store.commit("updateVisitorName", value);
      },
    },
    /** Visitor Email */
    visitorEmail: {
      get() {
        return this.$store.getters.visitorEmail;
      },
      set(value) {
        this.$store.commit("updateVisitorEmail", value);
      },
    },
    /** Visitor Phone */
    visitorPhone: {
      get() {
        return this.$store.getters.visitorPhone;
      },
      set(value) {
        this.$store.commit("updateVisitorPhone", value);
      },
    },
    /** Marketing consent */
    marketingConsent: {
      get() {
        return this.$store.getters.marketingConsent;
      },
      set(value) {
        this.$store.commit("updateMarketingConsent", value);
      },
    },
  },
  methods: {
    /**
     * Show the Contact Details Submission form.
     */
    show() {
      this.$modal.show("contact-details");
    },
    /**
     * Submit Contact Details.
     */
    submitContactDetails() {
      /**
       * If this.tableId is not empty is mean, the stickerID is available.
       * stickerId can be used to find out tableId.
       */
      if (this.stickerId && this.tables) {
        let tableObject = this.$_.findLast(this.tables, (item) => {
          return item.stickerId == this.stickerId;
        });

        /** If Table found with given table ID */
        if (tableObject) {
          this.tableId = tableObject.Id;
        }
      }
      this.isSubmitting = true;
      // save the userdetails in the cookies so we can use them through the application
      this.$store
        .dispatch("SUBMIT_VISITOR_DETAILS", {
          FullName: this.visitorName,
          Email: this.visitorEmail,
          Phone: this.visitorPhone,
          marketingConsent: this.marketingConsent,
          Table: this.tableId,
        })
        .then((response) => {
          /** If success response, store details to the cookies */
          if (response.status == 200) {
            /** Encrypting Name and Visitor Email. */
            let encryptedVisitorName = this.$aes.encrypt(this.visitorName);
            let encryptedVisitorEmail = this.$aes.encrypt(this.visitorEmail);
            let encryptedVisitorPhone = this.$aes.encrypt(this.visitorPhone);

            this.$cookies.set("n", encryptedVisitorName); // Name
            this.$cookies.set("e", encryptedVisitorEmail); // Email
            this.$cookies.set("p", encryptedVisitorPhone); // Phone
            this.$cookies.set("mc", this.marketingConsent); // Marketing Consent
            this.$cookies.set("vds", true); // visitorDetailsSubmitted
            this.$cookies.set("vdst", moment.now()); // visitorDetailsSubmittedTime
            this.$cookies.set("mi", this.menu.Id); // MenuId

            this.isSubmitting = false;
            this.visitorDetailsSubmitted = true;

            this.$modal.hide("contact-details");
          }
        });
    },
  },
  created() {
    /** Setting up $aes key for Encryption & Decryption. */
    this.$aes.setKey("W6{/}m>UU;Kh::+)");
    if (
      this.visitorPhone == "" &&
      this.visitorEmail == "" &&
      this.visitorName == ""
    ) {
      this.allFieldsFilled == false;
    }
  },
  mounted() {
    /**
     * Quick fix the stickerID of properly being populate in the contact tracing
     * as the sticker ID being retrived on a API call and need to wait to get
     * it updated.
     */
    setTimeout(() => {
      // this.stickerId = localStorage.getItem("stickerId");
    }, 1000);
    /** If Cookies has Key, Submit the data to the server.*/
    if (this.$cookies.isKey("vds")) {
      /**
       * Calculating truthy condition if the specified time interval allows the xhr.
       * e.g., making xhr/menu/hour
       */
      let isTimeAllowingCondition = moment(this.$cookies.get("vdst"), "x")
        .add(1, "hour")
        .isBefore(moment.now());

      /** Committing value to store after decrypting url-decoded cookie */
      this.$store.commit(
        "updateVisitorName",
        this.$aes.decrypt(decodeURI(this.$cookies.get("n")))
      );
      this.$store.commit(
        "updateVisitorEmail",
        this.$aes.decrypt(decodeURI(this.$cookies.get("e")))
      );
      this.$store.commit(
        "updateVisitorPhone",
        this.$aes.decrypt(decodeURI(this.$cookies.get("p")))
      );
      this.$store.commit(
        "updateMarketingConsent",
        eval(this.$cookies.get("mc"))
      );
      /**
       * Manually adding 1s delay before making any xhr call.
       *
       * Conditions ⤵
       * If MenuID stored in the cookie is same as the current requested MenuID
       * Check if 1 hour has been passed for same MenuID → Make xhr
       * If MenuID Doesn't match → Make xhr
       */
      setTimeout(() => {
        if (this.$cookies.get("mi") == this.menu.Id) {
          if (isTimeAllowingCondition) {
            this.submitContactDetails();
          }
        } else {
          this.submitContactDetails();
        }
      }, 1000);
    }

    /** If Cookies doesn't have the key, and auto-popup is enabled, open the modal */
    setTimeout(() => {
      if (
        !this.$cookies.isKey("vds") &&
        this.menu.is_contact_popup_enabled == true
      ) {
        this.$modal.show("contact-details");
      }
    }, 2000);
  },
  updated() {
    // check if all the input field are filled in
    if (
      this.visitorPhone != "" &&
      this.visitorEmail != "" &&
      this.visitorName != ""
    ) {
      this.allFieldsFilled = true;
    } else {
      this.allFieldsFilled = false;
    }
  },
};
</script>
<style scoped>
.restaurant-contact a::after {
  content: " | ";
}
.restaurant-contact a:last-of-type::after {
  content: "";
}
input:checked + svg {
  display: block;
}
</style>
